export default __webpack_public_path__ + "images/4bf9a8c57206a2fc276253a45269ef4d-music.png";